/* eslint-disable no-nested-ternary */
import { getRandomIntInclusive } from '@application/utils';
import { CardItem, SkeletonBox } from '@presentation/components';
import { useMemo } from 'react';

export const Skeleton = () => {
  const skeletons = useMemo(() => {
    return {
      title: { width: '100%', height: 21.5 },
      subtitle: { width: getRandomIntInclusive(60, 100), height: 21.7 },
      text: { width: getRandomIntInclusive(120, 160), height: 21.7 },
      footerText: { width: getRandomIntInclusive(120, 160), height: 19 },
    };
  }, []);
  return (
    <CardItem
      loading
      content={{
        title: <SkeletonBox style={{ ...skeletons.title }} />,
        subtitle: <SkeletonBox style={{ ...skeletons.subtitle }} />,
        text: <SkeletonBox style={{ ...skeletons.text }} />,
      }}
      footer={<SkeletonBox style={{ ...skeletons.footerText }} />}
    />
  );
};
